import { Injectable } from '@angular/core';

import { modeloGpsRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { configuracaoRoute, editRoute, newRoute } from "../../../shared/services/data.service";
import { rastreamentosRoute } from "../../shared/data.service";

@Injectable()
export class ModeloGpsNavigationService {
    moduleRouter: string = modeloGpsRoute;
    fatherRouter: string = rastreamentosRoute;
    configuracaoRoute: string = configuracaoRoute;

    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = this.fatherRouter + '/' + this.configuracaoRoute  + '/' + this.moduleRouter;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = this.fatherRouter + '/' + this.configuracaoRoute  + '/' + this.moduleRouter + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = this.fatherRouter + '/' + this.configuracaoRoute  + '/' + this.moduleRouter + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/shared/modelo-gps-navigation.service.ts
 **/